import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { RoleAccessService } from '../services/role-access.service';
import { MsalGuard } from '@azure/msal-angular';
import { firstValueFrom } from 'rxjs';
import { NavigationKeys } from '../utils/navigation.keys';

@Injectable({
  providedIn: 'root'
})
export class NavigationGuard  {

  constructor(
    private accessService: RoleAccessService,
    private router: Router,
    private msalGuard: MsalGuard
  ) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {

    const isAuthenticated = await firstValueFrom(this.msalGuard.canActivate(route, state)) as boolean;
    if (!isAuthenticated) {
      return false;
    }

    if (route.routeConfig?.path === NavigationKeys.Dashboard) {
      return true;
    }

    const routes: string[] = [];

    route.pathFromRoot.forEach(p => {
      if (p.routeConfig) {
        routes.push(p.routeConfig.path);
      }
    });

    const path = routes.join('/');
    const canAccess = await this.accessService.checkAccess(path);

    return canAccess;
  }

}
